import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';

export class DtoModifAddress {
  
    adressHistoryID: number;
    ShippingID: number;
    ExpDate: Date;
    AccountName: string;
  
    OldAddress1: string;
    OldAddress2: string;
    OldPostalCode : string;
    OldCity: string;
    OldPhone : string;

    NewAddress1: string;
    NewAddress2: string; 
    NewPostalCode: string;
    NewCity: string;
    NewPhone: string; 
    userID: number;
    DateInsert: Date;
    OldAccountName: string; 
    NewAccountName: string; 
    ExceptionCode: number;

    Latitude : number;
    Longitude : number;
}
